import Player from '@vimeo/player';

const players = [];
let videoCounter = 0;

function prepareVideo(video) {
  video.setAttribute('data-player-id', videoCounter);
  const videoContainer = video.querySelector('.c-video__video');

  if (videoContainer === null || videoContainer.tagName !== 'IFRAME') {
    return;
  }

  const player = new Player(videoContainer);
  const playButton = video.querySelector('.c-video__play');
  const progressBar = video.querySelector('.c-video__progress');
  const pauseButton = video.querySelector('.c-video__pause');
  const muteButton = video.querySelector('.c-video__mute');
  let played = false;

  if (playButton !== null) {
    playButton.addEventListener('click', event => {
      event.preventDefault();
      player.play().catch(error => {
        console.error(
          `Could not play video for player: ${error.message}`,
          player,
        );
      });
    });
  }

  if (pauseButton !== null) {
    pauseButton.addEventListener('click', event => {
      event.preventDefault();
      video.setAttribute('data-paused', '');
      player.pause().catch(error => {
        console.error(
          `Could not pause video for player: ${error.message}`,
          player,
        );
      });
    });
  }

  if (muteButton !== null) {
    muteButton.addEventListener('click', event => {
      event.preventDefault();
      player
        .setVolume(muteButton.classList.contains('muted') ? 1 : 0)
        .catch(error => {
          console.error(
            `Could not mute video for player: ${error.message}`,
            player,
          );
        });
    });

    player.on('volumechange', data => {
      if (data.volume === 0) {
        muteButton.classList.add('muted');
      } else {
        muteButton.classList.remove('muted');
      }
    });
  }

  player.on('ended', () => {
    video.classList.add('faded-out');

    setTimeout(() => {
      player.setCurrentTime(0);
      setTimeout(() => {
        video.classList.remove('faded-out');
      }, 200);
    }, 500);
  });

  player.on('play', () => {
    if (video.classList.contains('faded-out')) {
      video.classList.remove('faded-out');
    }

    if (!played) {
      played = true;

      player.getVolume().then(volume => {
        if (volume === 0) {
          muteButton.classList.add('muted');
        } else {
          muteButton.classList.remove('muted');
        }
      });
    }
  });

  if (progressBar !== null) {
    player.on('timeupdate', data => {
      progressBar.value = data.percent * 100;
    });

    progressBar.addEventListener('click', event => {
      event.preventDefault();
      const elementRect = event.target.getBoundingClientRect();
      const percentage = event.offsetX / elementRect.width;
      player
        .getDuration()
        .then(duration => {
          player.setCurrentTime(percentage * duration);
          progressBar.value = percentage * 100;

          if (video.classList.contains('faded-out')) {
            video.classList.remove('faded-out');
          }
        })
        .catch(error => {
          console.error(
            `Could not get video's duration for player: ${error.message}`,
            player,
          );
        });
    });
  }

  video.addEventListener('click', event => {
    if (event.target.classList.contains('c-video__video-wrapper')) {
      player
        .getPaused()
        .then(paused => {
          if (paused) {
            player.play();
          } else {
            player.pause();
            video.setAttribute('data-paused', '');
          }
        })
        .catch(error => {
          console.error(
            `Could not pause video for player: ${error.message}`,
            player,
          );
        });
    }
  });

  players[videoCounter] = player;

  videoCounter += 1;
}

function getVideoPlayer(el) {
  const videoContainer = el.hasAttribute('data-player-id')
    ? el
    : el.querySelector('[data-player-id]');
  const playerId =
    videoContainer !== null
      ? parseInt(videoContainer.getAttribute('data-player-id'), 10)
      : undefined;

  if (!Number.isNaN(playerId) && players[playerId] !== undefined) {
    return players[playerId];
  }

  return undefined;
}

function prepareVideos() {
  const videos = document.querySelectorAll('.c-video');
  [].forEach.call(videos, prepareVideo);
}

export { getVideoPlayer, prepareVideos as default };



// WEBPACK FOOTER //
// ./src/scripts/modules/videos.js